import './App.css';
import { Redirect, Route, Switch } from 'react-router-dom';
import Login from './components/pages/login/Login';
import { useAuth } from './components/providers/AuthProvider';
import { ROUTES_LIST } from './helpers/routesList';
import Dashboard from './components/Dashboard';
import RestorePassword from './components/pages/RestorePassword/RestorePassword';
import { useLocation, useHistory } from 'react-router-dom';
import RestorePasswordField from './components/pages/RestorePassword/RestorePasswordField';
import { useEffect } from 'react';

function App() {
    const auth = useAuth();
    const { pathname } = useLocation();
    const history = useHistory();

    useEffect(() => {
        if (auth.checkUserIsLogged() && pathname === ROUTES_LIST.login) {
            history.push({ pathname: ROUTES_LIST.dashboard });
        }
    }, [auth]);

    function redirect() {
        const userIsLogged = auth.checkUserIsLogged();

        if ((userIsLogged && pathname === ROUTES_LIST.login) || 
            (userIsLogged && pathname === '/')) {
            return <Redirect to={ROUTES_LIST.dashboard} />;
        } else if (userIsLogged) {
            return <Redirect to={pathname} />;
        } else if (pathname === ROUTES_LIST.restorePassword) {
            return <RestorePassword />;
        } else if (pathname === ROUTES_LIST.restorePasswordField) {
            return <RestorePasswordField />;
        } else {
            return <Redirect to={ROUTES_LIST.login} />;
        }
    }

    return (
        <>
            <Switch>
                <Route path={ROUTES_LIST.dashboard}>
                    <Dashboard />
                </Route>
                {/* <Route path={ROUTES_LIST.restorePassword}>
                    <RestorePassword />
                </Route> */}
                {/* <Route path={ROUTES_LIST.restorePasswordField}>
                    <RestorePasswordField />
                </Route> */}
                <Route path={ROUTES_LIST.login}>
                    <Login />
                </Route>
            </Switch>

            {redirect()}
        </>
    );
}

export default App;
